import React from "react";
import { Card } from "react-bootstrap";
import { Button } from "../../../../components/buttons";

export default function MultipleInputBox(props) {
  return (
    <Card style={{ maxHeight: "250px", minHeight: "100px", overflowY: "auto" }}>
      {props.waybillIds.map((id, idx) => (
        <div key={idx} className={`form-row py-1 ${idx % 2 !== 0 && "bg-gray-100"}`}>
          <div className="col-1 justify-center">{idx + 1}.</div>
          <div className="col-10 justify-center">
            <textarea
              type="text"
              className="overflow-hidden border-0"
              rows={1}
              style={{
                resize: "none",
                width: "100%",
                outline: 0,
                backgroundColor: "transparent",
              }}
              placeholder={
                idx === 0 && props.waybillIds.length <= 1
                  ? "Masukkan 1 (satu) nomor resi per baris"
                  : null
              }
              onChange={(e) => {
                props.onChangeInput(e.target.value, idx);
              }}
              value={id}
              autoFocus={idx === props.focus ? true : false}
              onFocus={(e) =>
                e.currentTarget.setSelectionRange(
                  e.currentTarget.value.length,
                  e.currentTarget.value.length
                )
              }
            />
          </div>
          <div className="col-1 justify-center">
            {props.waybillIds.length > 1 || props.waybillIds[0] ? (
              <Button
                type="button"
                onClick={() => props.onDeleteRow(idx)}
                className={`btn btn-secondary border px-2 py-0`}
              >
                <i className="fas fa-times fa-xs" />
              </Button>
            ) : null}
          </div>
        </div>
      ))}
    </Card>
  );
}
